var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.modal
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Install Site Seal ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "p",
              {
                staticClass: "mb-3 pt-2"
              },
              [
                _vm._v(
                  " Install your GlobalSign SSL Certificate Secure Site Seal by implementing the below script into your web site. "
                )
              ]
            ),
            _c(
              "textarea",
              {
                staticClass: "integration-code",
                attrs: {
                  readonly: "",
                  rows: "7"
                },
                on: {
                  click: function click($event) {
                    return $event.target.select()
                  }
                }
              },
              [
                _vm._v(
                  ' <span id="ss_img_wrapper_115-55_image_en"> <a href="http://www.alphassl.com/ssl-certificates/wildcard-ssl.html" target="_blank" title="SSL Certificates"> <img alt="Wildcard SSL Certificates" border=0 id="ss_img" src="//seal.alphassl.com/SiteSeal/images/alpha_noscript_115-55_en.gif" title="SSL Certificate"> </a> </span> <script type="text/javascript" src="//seal.alphassl.com/SiteSeal/alpha_image_115-55_en.js"></script> '
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }